import React, { useEffect, useState } from 'react';
import { Card, Button, Spinner, Form, Modal, Col, Row } from 'react-bootstrap';
import { useContextInfo } from '../../../context/ContextInfo';
import { useForm } from '../../../hooks/useForm';
import { fetchConToken } from '../../../api/fetch';
const initialState = {
    id: '',
    titulo: '',
    nota: '',
    seecl: false,
};
const EditDocument = ({ show, onClose, data, callBk }) => {
    const [validated, setValidated] = useState(false);
    const [load, setLoad] = useState(false);
    const { setResp } = useContextInfo();
    const [values, handleInputChange, setFormValue] = useForm(initialState);
    useEffect(() => {
        setFormValue({ ...initialState, ...data });
    }, [data]);
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            const res = await fetchConToken('user/docedit', { ...values }, 'PUT');
            setResp(res);
            callBk();
            setLoad(false);
            if (res.ok) onClose();
        }
        setLoad(false);
    };
    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header onHide={onClose} closeButton>
                <h4 className="modal-title">Editar Documento</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                                        <Form.Group className="mb-3" controlId="validationCustom999">
                                            <Form.Label>Titulo</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                value={values.titulo}
                                                name="titulo"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        <Form.Group className="mb-3" controlId="validationCusto">
                                            <Form.Label>Descripción</Form.Label>
                                            <Form.Control
                                                as={'textarea'}
                                                type="text"
                                                value={values.nota}
                                                name="nota"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        <Form.Group className="mb-3" controlId="validationCusto">
                                            <Form.Check
                                                type="switch"
                                                id="custom-switch"
                                                label=" Mostrar al cliente"
                                                checked={values.seecl}
                                                onChange={() => setFormValue({ ...values, seecl: !values.seecl })}
                                            />
                                        </Form.Group>{' '}
                                        {load ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Guardando...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Guardar</Button>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default EditDocument;
